import React from 'react';
import styles from './ContactFooter.module.css'; // This component will have its own styles





export default function ContactFooter({ 
    title = "Contact", // Default title
    description = "Feel free to reach out for collaborations or discussions.", // Default description
    email = "ai@entrosystem.com", // Default email
    copyrightText = `© ${new Date().getFullYear()} Entrosystem. All rights reserved.`, // Dynamic year
    // titleClassName = '', // Prop for external title styles
    // paragraphClassName = '' // Prop for external paragraph styles
    backgroundImageUrl,
}) {

    const containerWrapper = {
        // backgroundImage: `url(${backgroundImageUrl})`,
        // backgroundPosition: 'center 0%',
        };
        
    return (
        // The outer div uses this component's own CSS module for layout
        <div className={styles.containerWrapper} style={containerWrapper}>
            {/* The 'contact' section for content and navigation */}
            <section id="contact" className={styles.contactSection}>
                <p className={styles.paragraph}>{description}</p>
                <a href={`mailto:${email}`} className={styles.emailLink}>{email}</a>
            </section>
            
            {/* The 'footer' part of the component */}
            <footer className={styles.footerSection}>
                {copyrightText}
            </footer>
        </div>
    );
}